// المكافأةُ اليدويّة في كشف الرواتب وكشف الموظّف (components/attendance/payroll-manual-bonus.tsx).
const EN_B20: Record<string, string> = {
  "مكافأة يدوية": "Manual bonus",
  "المكافآت اليدوية": "Manual bonuses",
  "لا مكافأة يدوية لهذه الدورة": "No manual bonus for this cycle",
  "الأهلية": "Eligibility",
  "المكافأة": "Bonus",
  "منح": "Grant",
  "تأكيد الإلغاء": "Confirm revoke",
  "سبب المكافأة": "Bonus reason",
  "سبب الإلغاء": "Revoke reason",
  "الكشف معتمد — للعرض فقط": "Payslip approved — view only",
  "تعذّر الحفظ": "Could not save",
  "حُفظ ({n} — {m}) — أعِد احتساب الرواتب ليدخل الصافي": "Saved ({n} — {m}) — recalculate payroll for it to enter the net",
  "لم تُعرف نتيجة الحفظ ({n} — {m}) — أعِد المحاولة بالطلب نفسه قبل أيّ تعديل": "Save outcome unknown ({n} — {m}) — retry the same request before any change",
  "تغيّرت الفترة — أُلغي تعديلٌ غير محفوظ لـ{n}": "Period changed — an unsaved edit for {n} was discarded",
  "لم يعد التعديل ممكناً على هذه الدورة؛ راجع القائمة": "This change is no longer possible for this cycle; review the list",
  "إلغاء مكافأة": "Revoke bonus",
  "فترةٌ غير المعروضة": "not the period shown",
  "تغيّرت المكافأة على الخادم": "The bonus changed on the server",
  "لا مكافأة": "No bonus",
  "النسخة": "Version",
  "راجعتُ القيم الحالية — احفظ على هذه النسخة": "I reviewed the current values — save on this version",
  "إعادة المحاولة بالطلب نفسه": "Retry the same request",
  "ملاحظة يراها الموظف في كشفه (اختياري)": "Note the employee sees on the payslip (optional)",
  "ملاحظة الموظف على الخادم": "Employee note on the server",
  "لا ملاحظة للموظف على الخادم": "No employee note on the server",
  "لكلّ موظّفٍ نشط، معفىً من البصمة أو ملزَماً بها، وإن كان له عمولة تأجير أو توصيل. غيرُ النشط لا يُمنح. الصفرُ ليس مكافأة — استعمل «إلغاء».":
    "For every active employee — attendance-exempt or punch-required, including those with rental or delivery commission. Inactive staff cannot be granted. Zero is not a bonus — use “Revoke”.",
  "صفٌّ احتُسب قبل حفظ المكافأة اليدويّة": "Row calculated before manual bonuses were stored",
  "مخزنُ المكافأة غيرُ متاح": "Bonus storage unavailable",
  "احتُسب الصفّ بعد حفظ المكافأة بنسخةٍ لا تحفظها": "Row recalculated by a version that does not store the bonus",
  "المكافأةُ لا تطابق فترة الصفّ": "Bonus does not match the row period",
  "المكافأةُ لا تطابق صافي الصفّ": "Bonus does not match the row net",
  "نسخةُ مكافأةٍ غيرُ معروفة": "Unknown bonus version",
  "عُدّلت المكافأةُ أو أُضيفت بعد الاحتساب — أعِد الاحتساب": "Bonus added or changed after calculation — recalculate",
  "أُلغيت المكافأةُ بعد الاحتساب — أعِد الاحتساب": "Bonus revoked after calculation — recalculate",
  "تغيّرت أهليّةُ الموظّف بعد الاحتساب": "Employee eligibility changed after calculation",
  "نشط — مؤهّل": "Active — eligible",
  "غير نشط — غير مؤهّل": "Not active — not eligible",
  "غير معروف": "Unknown",
};
export default EN_B20;
